(() => {
  const dismiss = (section) => {
    const storageKey = section.dataset.announcementStorageKey;

    if (storageKey) {
      try {
        localStorage.setItem(storageKey, 'dismissed');
      } catch (error) {
        // Continue to hide the announcement bar if browser storage is unavailable.
      }
    }

    section.hidden = true;
    document.documentElement.style.setProperty('--announcement-bar-height', '0px');
  };

  const initialize = () => {
    document.querySelectorAll('[data-announcement-dismissible]').forEach((section) => {
      const storageKey = section.dataset.announcementStorageKey;

      try {
        if (storageKey && localStorage.getItem(storageKey) === 'dismissed') {
          dismiss(section);
        }
      } catch (error) {
        // Browsers that block storage should still show a working close button.
      }
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-action="dismiss-announcement"]');

    if (button) {
      dismiss(button.closest('[data-announcement-section]'));
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
